import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import PhotoChoicePage from "@/pages/PhotoChoicePage";
import ServicePage from "@/pages/ServicePage";
import BlogListPage from "@/pages/BlogListPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import { SERVICE_PAGES } from "@/lib/servicePages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />

          {/* Pages services */}
          {SERVICE_PAGES.map((s) => (
            <Route key={s.slug} path={s.path} element={<ServicePage slug={s.slug} />} />
          ))}

          {/* Blog */}
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />

          {/* Outils */}
          <Route path="/choix-photo" element={<PhotoChoicePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
